/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {SelectDropdownOptionModel} from '../../shared/select-dropdown/models/select-dropdown-option.model';
import {InputCriteriaCurrencyCodeEnum} from './input-criteria-currency-code.enum';

export const InputCriteriaCurrencyConfiguration: {
    readonly dropdownDefaultButtonText: string;
    readonly dropdownData: readonly SelectDropdownOptionModel[];
    readonly unit: string;
    readonly placeholder: string;
    readonly maxLength: number;
    readonly filterIntervalNumber: number;
    readonly currencyFormatErrorMessage: string;
} = {
    dropdownDefaultButtonText: 'Select criteria',
    dropdownData: [
        {
            code: InputCriteriaCurrencyCodeEnum.EQUAL_TO,
            name: 'Equal to',
            resultPrefix: 'Equal to'
        },
        {
            code: InputCriteriaCurrencyCodeEnum.BIGGER_THAN,
            name: 'Bigger than',
            resultPrefix: 'Bigger than'
        },
        {
            code: InputCriteriaCurrencyCodeEnum.EQUAL_OR_BIGGER_THAN,
            name: 'Equal or bigger than',
            resultPrefix: 'Equal or bigger than'
        },
        {
            code: InputCriteriaCurrencyCodeEnum.SMALLER_THAN,
            name: 'Smaller than',
            resultPrefix: 'Smaller than'
        },
        {
            code: InputCriteriaCurrencyCodeEnum.EQUAL_OR_SMALLER_THAN,
            name: 'Equal or smaller than',
            resultPrefix: 'Equal or smaller than'
        },
        {
            code: InputCriteriaCurrencyCodeEnum.BETWEEN,
            name: 'Between',
            resultPrefix: 'Between'
        }
    ],
    unit: '¥',
    placeholder: '00.00',
    maxLength: 20,
    filterIntervalNumber: 1e-6,
    currencyFormatErrorMessage: 'currency format. e.g. 00.00'
};
